import BaseModel from "./BaseModel";
import DateDialect from "../Enums/DateDialect";
import LngLatFormat from "../Enums/LngLatFormat";
import Company from "./Company";
import SatelliteViewType from "../UI/SatelliteView/Type";

//
// TODO: Magic/clever linked subscriptions?
//
// We want to come up with a way of subscribing user.company to a Company object, and e.g. user.tier to a Tier object too.
// Likewise we'll want to have Company.users link to these User objects, etc.
// How can we do this? Maybe Normalizr will help?

class User extends BaseModel {
	constructor(data) {
		super({}, User.defaults);
		this.data = data;
		this.company = null;
	}

	isNew() {
		return typeof this.id === "undefined" || this.id === -1;
	}

	get id() {
		return this.get("id");
	}

	get username() {
		return this.get("username");
	}

	get displayName() {
		const dn = this.get("displayname");
		if (dn && dn.length > 0) {
			return dn;
		}
		return this.get("username");
	}

	get email() {
		return this.get("email");
	}

	get companyId() {
		return this.get("company_id");
	}

	get features() {
		return this.get("features");
	}

	get featureOverrides() {
		return this.get("user_features");
	}

	get companyName() {
		if (this.companyId <= 0) {
			return "None";
		}
		return this.get("company_name");
	}

	get enabled() {
		return this.get("enabled");
	}

	get status() {
		return this.get("status");
	}

	get cognitoId() {
		return this.get("cognito_id");
	}

	get createdTimestamp() {
		return this.get("created_timestamp");
	}

	get modifiedTimestamp() {
		return this.get("modified_timestamp");
	}

	get extraData() {
		const extra = this.get("extra_data");

		extra.settings = extra.settings || {};
		extra.settings.date_dialect = extra.settings.date_dialect || User.defaults.extra_data.settings.date_dialect;
		extra.settings.lnglat_format = extra.settings.lnglat_format || User.defaults.extra_data.settings.lnglat_format;
		extra.settings.map = extra.settings.map || User.defaults.extra_data.settings.map;
		return extra;
	}

	set extraData(val) {
		this.data.extra_data = val;
	}

	get userDateDialect() {
		return this.extraData.settings.date_dialect;
	}

	get companyDateDialect() {
		if (this.company !== null) {
			return this.company.dateDialect;
		}
		return Company.defaults.extra_data.settings.date_dialect;
	}

	get dateDialect() {
		if (this.userDateDialect === DateDialect.NULL) {
			return this.companyDateDialect;
		}
		return this.userDateDialect;
	}

	get userLngLatFormat() {
		return this.extraData.settings.lnglat_format;
	}

	get userBathymetryEnabled() {
		return this.extraData.settings.map.bathymetry_enabled;
	}

	get userMapViewType() {
		return this.extraData.settings.map.view_type;
	}

	get userSatelliteViewOpacity() {
		return this.extraData.settings.map.view_opacity;
	}

	set userSatelliteViewOpacity(opacity) {
		this.data.extra_data.settings.map.view_opacity = opacity;
	}

	get companyLngLatFormat() {
		if (this.company !== null) {
			return this.company.lngLatFormat;
		}
		return Company.defaults.extra_data.settings.lnglat_format;
	}

	get lngLatFormat() {
		if (this.userLngLatFormat === LngLatFormat.NULL) {
			return this.companyLngLatFormat;
		}
		return this.userLngLatFormat;
	}

	get defaultLngLatStr() {
		if (this.lngLatFormat === LngLatFormat.DMS) {
			return "0° 0' 0'' E, 0° 0' 0'' N";
		}
		return "0, 0";
	}

	update(data) {
		super.setData(data);
	}

	asSaveData() {
		return {
			id: this.id,
			username: this.username,
			extra_data: this.extraData,
			features: this.features
		};
	}
}
User.defaults = { // Defaults
	id: -1,
	username: "",
	displayname: "",
	email: "",
	company_id: -1,
	company_name: "",
	features: {},
	enabled: false,
	status: "RESET_REQUIRED",
	cognito_id: "",
	created_timestamp: 0,
	modified_timestamp: 0,
	extra_data: {
		settings: {
			date_dialect: DateDialect.NULL,
			lnglat_format: LngLatFormat.NULL,
			map: {
				bathymetry_enabled: false,
				view_type: SatelliteViewType.OFF,
				view_opacity: 1.0
			}
		}
	}
};

export default User;
